/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import getWindow from './getWindow';

export class LocalStorage {
    constructor({ windowInterface }) {
        this.localStorage = null;

        // dependency injection
        if (windowInterface && windowInterface.localStorage) {
            this.localStorage = windowInterface.localStorage;
        }
    }

    get(key) {
        if (!this.localStorage) {
            return null;
        }

        const val = this.localStorage.getItem(key);

        return val;
    }
}

const window = getWindow();
const localStorage = new LocalStorage({
    windowInterface: window,
});

export default localStorage;
